<mat-toolbar color="primary">
  <span id="signering-avslutt-dialog-tittel">
    {{ 'Avslutt signeringen for  \'{filnavn}\'' |translate: {filnavn: dokumentversjon.filnavn} }}
  </span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>

@if (modus() == 'vis') {
  <mat-dialog-content>
    <tips>
      {{ 'Signaturbevis vil bli generert og signatarer som ikke har signert enda vil ikke lenger kunne signere dette dokumentet.'|translate }}
    </tips>
    <signering-status [signatarer]="signatarer()" [status]="dokumentversjon.signeringStatus" visSendPaaminnelse="false"/>

  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <span>
      <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
      <button mat-raised-button type="button" color="primary" cdkFocusInitial (click)="avsluttSignering()" [disabled]="lagrer()"
              [visSpinner]="lagrer()" [spinnerTekst]="'Avslutter...'|translate" data-testid="lagre-knapp">
        {{ "Avslutt signering"|translate }}
      </button>
    </span>
  </mat-dialog-actions>
}

@if (modus() == 'kvittering') {
  <mat-dialog-content data-testid="avslutt-signering-kvittering">
    <p>{{ 'Signeringsprosessen har blitt avsluttet'|translate }}</p>
    <tips class="std-margin-vertikal">
      {{ 'En ny endelig versjon av det signerte dokumentet lages og vil snart være synlig.'|translate }}
    </tips>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <span>
      <button mat-button type="button" (click)="ferdig()">{{ "Ok"|translate }}</button>
    </span>
  </mat-dialog-actions>
}
